import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cached = null;
let _fetching = false;
let _listeners = [];

function notifyAll(data) {
  _listeners.forEach(fn => fn(data));
}

export function useReviewStats() {
  const [stats, setStats] = useState(_cached || { count: 36, average_rating: 5.0 });

  useEffect(() => {
    _listeners.push(setStats);

    if (_cached) {
      setStats(_cached);
    } else if (!_fetching) {
      _fetching = true;
      axios.get(`${API}/reviews/stats`)
        .then(res => {
          _cached = res.data;
          notifyAll(_cached);
        })
        .catch(() => {})
        .finally(() => { _fetching = false; });
    }

    return () => {
      _listeners = _listeners.filter(fn => fn !== setStats);
    };
  }, []);

  return stats;
}
